// [PACKAGE] - Packeta
// https://widget.packeta.com/v6/doc/standard-example-simple.html
// [TODO] update podla aktualneho ID
const packetaId = [1, 3, 10];
const standTextCategoryId = 7;
const standTextProductId = [13, 14];
const rotationCategoryId = [1, 4];
const fullwidthCategoryId = [1, 4, 5];
const deliveryTime = 48;
const instaCategoryId = 2;
const musicCategoryId = 3;
const customCategoryId = 4;
const photoCategoryId = 5;
const accessoryCategoryId = 6;
const giftPackagingId = 42;
const giftDedicationPackagingId = 43;
const engravedOakMassifId = 7;
const acrylicStandId = 28;
const engravedBlackOakMassifId = 38;
const blackOakMassifId = 27;
const luminousOakMassifId = 40;
const bigSizeId = 4;
const magneticStand = 39;
const noStandId = 5;
const giftVoucherIds = [40, 41];

export {
  packetaId,
  standTextCategoryId,
  fullwidthCategoryId,
  standTextProductId,
  rotationCategoryId,
  deliveryTime,
  instaCategoryId,
  musicCategoryId,
  customCategoryId,
  photoCategoryId,
  accessoryCategoryId,
  giftDedicationPackagingId,
  giftPackagingId,
  engravedOakMassifId,
  engravedBlackOakMassifId,
  blackOakMassifId,
  luminousOakMassifId,
  bigSizeId,
  magneticStand,
  acrylicStandId,
  noStandId,
  giftVoucherIds,
};
